import Vue from 'vue';
import WalletBar from "../../parts/WalletBar.vue";
import NavigationDrawer from "../../parts/NavigationDrawer.vue";
import QRLabView from "./QRLab.vue";
import ReceiveView from "./Receive.vue";
import HomeView from "./Home.vue";
import SendView from "./Send.vue";
import ScanView from "./Scan.vue";
export default Vue.extend({
    components: {
        WalletBar,
        NavigationDrawer,
        QRLabView,
        ReceiveView,
        HomeView,
        SendView,
        ScanView,
    },
    name: 'Top',
    data() {
        return {
            drawer: false,
            items: [
                { to: 'qrlab', label: 'QR Lab', icon: 'icon_home_qr_labo_green.png' },
                { to: 'receive', label: 'RECEIVE', icon: 'icon_home_receive_green.png' },
                { to: 'home', label: 'HOME', icon: 'icon_home_home_green.png' },
                { to: 'send', label: 'SEND', icon: 'icon_home_send_green.png' },
                { to: 'scan', label: 'SCAN', icon: 'icon_home_scan_green.png' },
            ],
        };
    },
    computed: {
        displayTab: {
            get: function () {
                return this.tab;
            },
            set: function (newValue) {
                this.$router.replace('/top?tab=' + newValue);
            }
        }
    },
    props: {
        tab: {
            type: String,
            default: 'home'
        },
    },
    mounted() {
        if (this.tab.length > 0) {
            this.displayTab = this.tab;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/top/Top.vue
// module id = 321
// module chunks = 1